module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/4-active-fb195d6b2dc2f5066bcf547b10286700.png";